import { render, staticRenderFns } from "./user-media.vue?vue&type=template&id=313edac9&scoped=true&"
import script from "./user-media.vue?vue&type=script&lang=js&"
export * from "./user-media.vue?vue&type=script&lang=js&"
import style0 from "./user-media.vue?vue&type=style&index=0&id=313edac9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313edac9",
  null
  
)

export default component.exports